import React from 'react'
import Icon from '@material-ui/icons/Check';
import { blackColor } from 'assets/jss/material-dashboard-react';

export const CheckIcon = (props) => {
  return (
    <Icon {...props} style={{ ...props.style, color: blackColor }} />
  )
}
